<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Detect Detail</strong> <span class="float-right" style="font-size: 13px">Detect Time {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_agent" v-b-tooltip.hover title="Agent">Agent</label><br>
                <label for="ph_agent" v-if="model.agent">{{`${model.agent.name} (${model.agent.host}@${model.agent.ip_addr})`}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_path" v-b-tooltip.hover title="Path">Path</label><br>
                <label for="ph_path" style="width:100%; background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;">{{model.path}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_category" v-b-tooltip.hover title="Category">Category</label><br>
                <label for="ph_category" v-if="model && model.category">{{model.category}}</label>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="model">
              <b-form-group>
                <label for="ph_ext" v-b-tooltip.hover title="Value">Value</label><br>
                <label for="ph_ext" v-if="model && model.description">{{model.description.value || 'None'}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_is_backup" v-b-tooltip.hover title="Backup Mode">Backup Mode</label><br>
                <label for="ph_is_backup" >{{model.is_backup ? 'use' : 'unuse'}}</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group >
                <label for="ph_type" v-b-tooltip.hover title="Type">Type</label><br>
                <label for="ph_type" v-if="model.description && model.description.type">{{model.description.type ? model.description.type : codes.code_type[model.type] }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_code" v-b-tooltip.hover title="Code">Code</label><br>
                <label for="ph_code" v-if="model.description">{{model.description.code || 'undefined'}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group v-if="model && model.description && model.description.type != 'md5'">
                <label for="ph_numerical" v-b-tooltip.hover title="Line">Line</label><br>
                <label for="ph_numerical"> {{model.description.numerical}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Api, auth } from '@/service';
import codes from '@/codes';

export default {
  data : () => {
    return { model : {}, codes }
  },
  methods: {
    list() { this.$router.push({ name: 'wsfinder_detect'}); },
    async get({ id } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      try {
        let rs = await Api.Manager_Call('wsfinder.detect', 'detail', {id : id});
        this.model = Object.assign({ group: {} }, this.model, rs.body)
        this.model.description = JSON.parse(rs.body.description);
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('detect.detail.vue', 'created'); },
  destroyed: function() { console.log('detect.detail.vue', 'destroyed'); },
  mounted: function() { console.log('detect.detail.vue', 'mounted'); this.get(this.$route.params); },
}
</script>
